import clsx from 'clsx';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import styles from './Info.module.scss';
import { InfoProps } from './Info.type';

export const Info: FunctionComponent<InfoProps> = ({
    tabs,
    activeTab,
    children,
}) => {
    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                {Object.keys(tabs).map((item) => (
                    <Link key={item} href={`/info/${item}`}>
                        <a
                            className={clsx(
                                styles.tabItem,
                                activeTab === item && styles.active
                            )}
                        >
                            {tabs[item].name}
                        </a>
                    </Link>
                ))}
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
};
